import { type WalletLedger, type WalletWithTotalAmountDTO } from '@capsicum/common';
import { useCallback } from 'react';

import { useWalletQuery } from '../data-access';
/**
 *
 * @param currencyId
 * @returns balance and convertedPrices of selected currency
 */
export const useWalletBalance = (currencyId?: string) =>
	useWalletQuery(
		useCallback(
			(data: undefined | WalletWithTotalAmountDTO) => {
				const { balance, convertedPrices, lockedBalance } =
					(data?.ledgers?.find(l => l?.currency?.id === currencyId) as WalletLedger) || [];

				return {
					balance,
					convertedPrices,
					lockedBalance
				};
			},
			[currencyId]
		)
	);
